import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { Storage } from '@ionic/storage-angular'

@Component({
  selector: 'app-btn-support',
  templateUrl: './btn-support.component.html',
  styleUrls: ['./btn-support.component.scss']
})
export class BtnSupportComponent implements OnInit {
  @Input() message: any
  urlMessage: string
  btnWhatsApp = 1

  public storage_user: Storage | null = null

  constructor(public storage: Storage, public router: Router) {}

  async ngOnInit() {
    this.urlMessage = 'https://wa.me/5491122427997/?text=' + this.message

    const storage = await this.storage.create()
    this.storage_user = storage
    this.validateCountry()
  }

  validateCountry() {
    this.storage_user?.get(environment.localStorage).then((r) => {
      if (r != null) {
        if (r.country_name == 'Chile') {
          this.btnWhatsApp = 0
        }
      } else {
        this.storage.set(environment.localStorage, null)
        this.router.navigate(['login'])
      }
    })
  }
}
